<section>
    <div class="warning-icon">
        <mat-icon>warning</mat-icon>
    </div>
    <div class="warning-content">
        <span class="warning-title">{{title}}</span>
        <p class="warning-message" >{{message}}</p>
    </div>
    <div mat-dialog-actions class="button-content">
        <button mat-raised-button mat-dialog-close class="warning--button">OK</button>
    </div>
</section>
